import React from 'react';
import '../../assets/css/Legal.css';

const TermsConditions = () => {
  return (
    <div className="legal-page">
      <section className="hero-section">
        <div className="container">
          <div className="hero-content">
            <h1>Terms and Conditions</h1>
            <p className="hero-subtitle">
              Guidelines for using Samyama website and services
            </p>
          </div>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <div className="legal-content">
            <div className="legal-meta">
              <p><strong>Effective Date:</strong> 01-June-2025</p>
              <p><strong>Next Update:</strong> 01-Dec-2025</p>
              <p><strong>Website:</strong> <a href="http://samyama.ai" target="_blank" rel="noopener noreferrer">https://www.samyama.ai</a></p>
              <p><strong>Operated by:</strong> VaidhyaMegha Private Limited</p>
            </div>
            

            <div className="legal-section">
              <h2>1. Acceptance of Terms</h2>
              <p>
              By accessing, browsing, registering, or otherwise using any portion of the Samyama website or its services (including those redirected from vaidhyamegha.com), you confirm that you have read, understood, and expressly agree to be legally bound by these Terms & Conditions ("Terms"), as well as any applicable policies referenced herein (including our Privacy Policy and Cookie Policy).
              </p>
              <p>
              If you do not agree with any part of these Terms, you must immediately discontinue access to the platform and cease using any related services.
              </p>
              <p> 
              Your continued use of Samyama constitutes:
              </p>
              <ul>
                <li>
                A legally binding agreement between you and VaidhyaMegha Private Limited, the owner and operator of the platform;
                </li>
                <li>
                Your affirmation that you are legally eligible to use the services under applicable law and possess the full authority to accept these Terms. 
                </li>
              </ul>
              <p>
              These Terms apply to all users, including but not limited to:
              </p>
              <p>
              Registered users
              <br />
              Guest visitors
              <br />
              Legal entities using the services for business purposes
              <br />
              Authorized representatives acting on behalf of others
              </p>
            </div>

            <div className="legal-section">
              <h2>2. Services Offered</h2>
              <p>
              Samyama, a digital platform operated by VaidhyaMegha Private Limited, offers a suite of AI-powered tools and services designed to enhance productivity, wellness, and digital intelligence. These services may include, but are not limited to:
              </p>
              <ul>
                <li>
                AI-assisted virtual healthcare support (non-diagnostic, informational assistance)
                </li>
                <li>
                Knowledge systems for decision support and research
                </li>
                <li>
                Workflow automation and productivity tools
                </li>
                <li>
                Secure access to cloud-hosted and data-driven AI models and interfaces
                </li>
              </ul>
              <p>
              platform—whether technical, legal, or ethical—may result in immediate restriction or termination of access.
              </p>
              <p>
              Platform Evolution and Changes
              </p>
              <p>
              VaidhyaMegha Private Limited reserves the right to:
              </p>
              <ul>
                <li>
                 Add, update, restrict, or discontinue any part of the service;
                </li>
                <li>
                 Modify or suspend features, pricing models, service tiers, or APIs;
                </li>
                <li>
                 Perform scheduled or emergency maintenance, with or without advance notice.
                </li>
              </ul>
              <p>
              Such changes may be made at our sole discretion, and without liability to users or third parties for any resulting service interruptions, loss of access, or feature deprecation.
              </p>
            </div>

            <div className="legal-section">
              <h2>3. Eligibility</h2>
              <p>
              To access or use any part of Samyama, you must meet the following eligibility criteria:
              </p>
              <p>
              Minimum Age Requirement
              </p>
              <p>
              You must be at least 18 years of age, or 16 years old with verifiable parental or legal guardian consent, to create an account, submit personal data, or use any feature that involves processing sensitive information.
              </p>
              <p>
              Legal Capacity
              </p>
              <p>
 You must be legally competent to enter into a binding agreement under applicable national and international laws. This includes being of sound mind and not disqualified from contracting by any judicial order or legal incapacity.
              </p>
              <p>
              Prohibited User Restrictions
              </p>
              <p>
              You must not be a person or entity barred from accessing digital platforms or online services under:
              </p>
              <ul>
                <li>
                 The laws of India
                </li>
                <li>
                 Any other jurisdiction that applies to you
                </li>
                <li>
                 International sanctions lists (e.g., OFAC, UN sanctions)
                </li>
              </ul>
              <p>
              VaidhyaMegha Private Limited reserves the right to deny, suspend, or revoke access to any user who fails to meet these eligibility conditions, with or without prior notice.</p>
            </div>

            <div className="legal-section">
              <h2>4. User Accounts and Access</h2>
              <p>
              To access and utilize certain features or services on Samyama, you may be required to register for a user account by providing accurate, current, and complete information. By doing so, you agree to the following:
              </p>
              <p>
              Account Security and Responsibility
              <ul>
                <li>
                You are solely responsible for:
                 <ul>
                   <li>
                   Maintaining the confidentiality of your login credentials (e.g., username, password, authentication tokens).
                   </li>
                   <li>
                   All activities conducted under your account, regardless of whether they were authorized by you
                   </li>
                 </ul>
                </li>
                <li>
                You must notify us immediately at privacy@samyama.ai in case of:
                </li>
                <p>
                Any suspicious activity on your account;
                <ul>
                  <li>
                  Loss or compromise of your login credentials;
                  </li>
                  <li>
                  Unauthorized use or suspected breach.
                  </li>
                </ul>
                </p>
              </ul>
              </p>
              <p>
              Prohibited Account Activities
              </p>
              <p>
              The following actions are strictly prohibited and may result in account suspension or permanent ban:
              </p>
              <p>
              Impersonation of another person, organization, or legal entity;
              <br />
              Sharing your account or credentials with others, including coworkers or family members;
              <br />
              Creating multiple accounts to bypass restrictions or manipulate system outputs;
              <br />
              Accessing or attempting to access accounts or services you are not authorized to use.
              <br />
              <p>
              VaidhyaMegha Private Limited reserves the right to audit, suspend, or terminate accounts found in violation of these terms, with or without notice.
              </p>
              </p>
            
              <div className="legal-section">
              <h2>5. Acceptable Use Policy</h2>
              <p>
              By using Samyama, you agree to act responsibly, ethically, and in compliance with all applicable laws. The following uses of the platform are strictly prohibited:
              </p>
              <p>
              Violating any law, rule, or regulation, including those related to data protection, cybercrime, export controls, and healthcare communication.
              <br />
              Reverse engineering, scraping, mining, or attempting to extract source code, models, APIs, or proprietary algorithms.
              <br />
              Transmitting malicious code, including viruses, worms, trojans, malware, spyware, or engaging in spamming, bot attacks, or DDoS attempts.
              <br />
              Using AI outputs to generate or distribute content that is:
              <ul>
                <li>
                Harmful, misleading, or deceptive;
                </li>
                <li>
                Discriminatory, abusive, hateful, or defamatory;
                </li>
                <li>
                Medical or legal advice passed off as professional counsel without disclaimer.
                </li>
              </ul>
              Infringing upon intellectual property rights belonging to VaidhyaMegha Private Limited, its licensors, or any third party.
              </p>
              <p>
              Any violation may result in immediate account suspension, termination, and potential legal action, including IP address blocking or law enforcement reporting.
              </p>
            </div> 
            <div className="legal-section">
              <h2>6. Intellectual Property</h2>
              <p>
              All content, functionality, and services made available on Samyama are protected by intellectual property laws and are the exclusive property of VaidhyaMegha Private Limited or its authorized licensors. This includes, without limitation:
              </p>
              <p>
               AI models, APIs, and algorithms
              <br />
Designs, user interfaces, and visual assets
<br />
Documentation, instructional content, and datasets
<br />
® Trademarks, service marks, brand names, and logos
<br />
Software source code, backend frameworks, and architecture

              </p>
              <p>
               Permitted Use
              </p>
              <p>
              Users are granted a limited, non-exclusive, non-transferable, revocable license to access and use the platform solely for:
              </p>
              <ul>
                <li>
                Personal, non-commercial use; or
                </li>
                <li>
                Authorized internal business use (if contractually permitted)
                </li>
              </ul>
              <p>
              Restricted Use
              </p>
              <p>
              You may not copy, modify, reproduce, distribute, sublicense, publish, or create derivative works from any part of the platform without prior written consent from VaidhyaMegha.Any unauthorized use of Samyama’s intellectual property may result in legal proceedings for copyright infringement, breach of contract, or statutory violations.
              </p>
            </div>

            <div className="legal-section">
              <h2>7. Disclaimers</h2>
              <p>
              The services provided by Samyama are offered strictly on an “as is” and “as available” basis, without any warranties of any kind, whether express, implied, or statutory.
              </p>
              <p>
              Specifically:
              <br />
              We make no guarantees regarding the accuracy, completeness, timeliness, or reliability of content generated by our AI systems, APIs, or user-facing tools.
              <br />
              Any information provided by AI-based healthcare modules is purely informational and not a substitute for professional medical diagnosis, advice, or treatment. Always consult a qualified physician or healthcare provider for personal medical decisions.
              <br />
              Platform availability, uptime, or error-free operation is not guaranteed, especially during updates, maintenance, or third-party disruptions.
              </p>
              <p>
              Warranty Disclaimer:
              <br />
              VaidhyaMegha Private Limited expressly disclaims all warranties, whether:
              <ul>
                <li>
                Express, such as performance guarantees;
                </li>
                <li>
                Implied, including but not limited to merchantability, fitness for a particular purpose, or non-infringement;
                </li>
                <li>
                Statutory, arising from usage or trade custom.
                </li>
              </ul>
              <p>
              Users assume full responsibility for any risk or loss arising from their use of the platform or reliance on any AI output.
              </p>
              </p>
            </div>

            <div className="legal-section">
              <h2>8. Limitation of Liability</h2>
              <p>
              To the maximum extent permitted by applicable law, VaidhyaMegha Private Limited and its affiliates, officers, directors, employees, licensors, and partners shall not be held liable for any:
              <br />
              Indirect, incidental, consequential, punitive, or special damages;
              <br />
              Loss of business, revenue, profits, anticipated savings, goodwill, or data;
              <br />
              Damages arising out of your use of or inability to use the Samyama platform or its content.
              </p>
              <p>
              Maximum Liability Cap:
              <br />
              In all cases, our total aggregate liability for any claim related to use of the service shall be limited to the amount paid by you (if any) in the 12 months preceding the event giving rise to such liability.
              <br />
              This limitation shall apply regardless of the form of action—whether in contract, tort, negligence, strict liability, or otherwise—and even if we have been advised of the possibility of such damages.
              </p>
            </div>

            <div className="legal-section">
              <h2>9. Data Privacy and Protection</h2>
              <p>
              Your use of Samyama is governed by our separate, detailed Privacy Policy which outlines:
              <br />
              What data we collect;
              <br />
              How we store, process, and secure it;
              <br />
              What rights you have over your data;
              <br />
              Our legal obligations under applicable privacy frameworks.
              <br />
              <p>
              By using Samyama, you expressly consent to:
              <ul>
                <li>
                The data practices described in our Privacy Policy;
                </li>
                <li>
                The use of your personal and technical information for the purposes of delivering, securing, and improving the platform.
                </li>
              </ul>
              </p>
              </p>
            </div>

            <div className="legal-section">
              <h2>10. Termination</h2>
              <p>
              VaidhyaMegha Private Limited reserves the right to suspend, limit, or permanently terminate your access to Samyama, with or without notice, at our sole discretion, under any of the following circumstances:
              <br />
              You violate these Terms & Conditions or any other linked policy (e.g., Privacy Policy, Acceptable Use Policy).
              <br />
              You compromise the platform's integrity, security, infrastructure, or attempt unauthorized access or exploitation of system resources.
              <br />
              You engage in any form of abusive, illegal, unethical, or harassing behavior toward the platform, its services, its staff, or other users.
              </p>
              <p> 
              Additional Provisions:
              <ul>
                <li>
                Termination includes deactivation or deletion of your account, revocation of access to services, and removal of any user-generated content associated with the account.
                </li>
                <li>
                No refunds or compensation will be issued for any unused services, paid plans, or subscriptions in the event of a termination due to breach.
                </li>
                <li>
                Termination does not limit or waive our right to pursue legal remedies, including claims for monetary damages, injunctive relief, or other equitable remedies under applicable law.
                </li>
              </ul>
              <p>
              Continued attempts to access the platform after termination may result in legal action or IP/network blocking.
              </p>
              </p>
            </div>
            
            <div className="legal-section">
              <h2>11. Policy Updates</h2>
              <p>
              VaidhyaMegha Private Limited reserves the right to revise, update, or amend these Terms & Conditions at any time to reflect:
              <ul>
                <li>
                Changes in applicable laws or regulatory frameworks (e.g., Indian IT Act, GDPR, DPDP Act);
                </li>
                <li>
                Introduction of new features, services, or AI modules that may impact data usage or user obligations;
                </li>
                <li>
                Clarification, rewording, or reorganization of terms for better user understanding or legal precision.
                </li>
              </ul>
              <p>
              Notification of Changes
              <br />
              We are committed to transparency. When a material change occurs:
              <br />
              You will be notified at least 15 calendar days in advance, through one or more of the following channels:

              <ul>
                <li>
                An on-site notification banner or system message;
                </li>
                <li>
                Email notification to your registered address (if provided);
                </li>
                <li>
                Posting the revised Terms with a clearly marked effective date.
                </li>
                <li>
                Your continued use of the platform after the effective date of changes constitutes your acceptance of the revised Terms. If you do not agree with the changes, you may discontinue using the service before the new Terms take effect.
                </li>
              </ul>
              </p>
              </p>
            </div>
            
            <div className="legal-section">
              <h2>12. Governing Law and Jurisdiction</h2>
              <p>
              These Terms & Conditions are governed by and construed in accordance with the laws of India 🇮🇳, without regard to any conflict-of-law principles.
              <br />
              You agree that the courts located in Hyderabad, India 🏛️ shall have exclusive jurisdiction over any dispute, claim, or legal proceeding arising out of or relating to:
              <ul>
                <li>
                Your use of Samyama;
                </li>
                <li>
                The interpretation or enforcement of these Terms;
                </li>
                <li>
                Any associated services, contracts, or transactions.
                </li>
                <li>
                Any transactions or agreements entered into through the platform;
                </li>
              </ul>
              <p>
              By using the platform, you consent to submit to the jurisdiction of Indian courts for any legal matter related to these Terms.
              </p>
              </p>
              </div>

              <div className="legal-section">
              <h2>13. Changes to Terms</h2>
              <p>
              We may revise or update these Terms & Conditions periodically to reflect changes in:
              <ul>
                <li>
                Legal or regulatory requirements
                </li>
                <li>
                Platform functionality and services
                </li>
                <li>
                Clarity, transparency, or editorial improvements
                </li>
              </ul>
              <p>
              Advance Notice
              <br />
              You will be notified of any material changes at least 15 days in advance through:
              <ul>
                <li>
                A banner or alert on the Samyama website
                </li>
                <li>
                An email to your registered address (if applicable)
                </li>
              </ul>
              <p>
                Implied Acceptance
                <br />
                Your continued use of the platform after the effective date of the updated Terms will be deemed as your acceptance of the changes.
                <br />
                If you do not agree with the revised Terms, you must discontinue use of the platform before the effective date.
              </p>  
              </p>
              </p>
              </div>

              <div className="legal-section">
              <h2>14. Contact Information</h2>
              <p>
              If you have any questions, concerns, or requests regarding these Terms & Conditions or your use of Samyama, please reach out to us:
              </p>
              <p>
              VaidhyaMegha Private Limited
              </p>
              <p>
              Email: enquiry@samyama.ai
              </p>
              <p>
              Phone: +91 9618986039
              </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default TermsConditions;
